import { ImageClass, SubVertical, WeekDayOffType, WeekDayType } from 'common/constants'
import SellerActionGrade from 'common/constants/sellerActionGrade'
import BusinessType from 'common/constants/businessType'
import SellerRepresentativeType from 'common/constants/sellerRepresentType'
import { ShoppingCenter } from './window'
import { replaceToHttps } from '@shopping/Img'

export interface SSChannel {
  id: string
  regDate?: string
  modDate?: string
  channelServiceType: string
  channelExternalStatusType: ExternalStatus
  sellerStatusReasonType: string
  channelName: string
  categoryId: string
  representImageInfoList: ChannelImage[]
  additionalImageInfoList: ChannelImage[]
  channelValidProductCount: number
  siteChannelInterlockYn: boolean
  description: string
  detailIntroductionContent: string
  salesTimeInfo: ChannelSaleTime
  contactInfo?: ChannelContact
  bestShopYn: boolean
  exhibitionYn: boolean
  representNo: number
  representType: SellerRepresentativeType
  identity: string
  representName: string
  representativeBirthDay?: string
  representativeName: string
  corporationRegistrationNumber?: string
  businessConditionName?: string
  categoryItemName: string
  businessType: BusinessType
  isOverSeaProductSales: boolean
  nation: string
  businessAddressInfo: ChannelAddress
  accountNo: number
  accountId?: string
  defaultChannelNo: number
  productDeliveryType: string
  importType: string
  advertiser: boolean
  advertizerSubscriptionDate: string
  mallSeq: number
  naverAccountId?: string
  agencyId?: string
  accountAddType: string
  domesticTelephoneNumber?: Tel
  overseasTelephoneNumber?: Tel
  storeExposureInfo: ExposureInfo
  accountAdmissionDate: string
  accoauntValidProductCount: number
  accountExternalStatusType: string
  naverPayExternalStatusType: string
  chrgrName?: string
  chrgrCellPhoneNumber?: Tel
  chrgrEmail: string
  naverPayNo: number
  payReferenceKey: string
  payType: string
  deliveryPlaceModifyYn: boolean
  claimRepealYn: boolean
  creditScore: number
  actionGrade: SellerActionGrade
  serviceSatisfactionGrade: boolean
  saleCount: number
  csResponseRatio: number
  in2DaysDeliveryCompleteRatio: number
  averageSaleSatificationScore: number
  cumulationSaleAmount: number
  cumulationSaleCount: number
  purchaseCustomerCountBy3Month: number
  windowSubVertical: SubVertical
  windowCategoryId: string
  windowCategoryName: string
  naverPayUseYn: boolean
  inquiryUseYn: boolean
  productInspectionSkipYn: boolean
  additionalAttribute: ChannelAdditionalAttribute
  naSiteId: string
  fullUrl: string
  mobileUrl: string
  accountValidProductCount?: number
  apiId?: string
  channelAdmissionDate?: string
  couponPublicationAgreeDate?: string
  couponPublicationAgreeStatusType?: string
  danawaJoinStatusType?: string
  declaredToOnlineMarkettingNumber?: string
  deliveryDelayException?: boolean
  detailExtendIntroductionContent?: string
  enuriJoinStatusType?: string
  grafolioNo?: number
  identityAuthType?: string
  leaveDate?: string
  lotNumberAddressExclusiveYn?: boolean
  modooNo?: number
  naverAnalytics?: string
  propensityType?: string
  realNameCertificatedDate?: string
  socialSecurityNumberGathering?: boolean
  talkAccountId?: string
  talkExposureYn?: boolean
  url?: string
  domesticTelephoneNumberReported: boolean
  supplyAccountId?: string
  supplyAccountNo?: number
  supplyNaverPayNo?: number
  supplyNaverPayReferenceKey?: string

  // Temp
  logoImage: ChannelImage
  shoppingCenter?: ShoppingCenter
  storeCategoryIds?: string[]
}

export interface ChannelAdditionalAttribute {
  channelAlias?: string
  handleBrandNames?: string[]
  handleSpecificGoods?: string[]
  smartPlaceInfo?: SmartPlaceInfo
  se3ContentsSeq?: number
  storeNaverMapMobileUrl?: string
  storeNaverMapUrl?: string
}

export interface SmartPlaceInfo {
  latitude?: number
  longitude?: number
  exposedId?: number
}

export interface ExposureInfo {
  exposureInfo: any
}
export interface ChannelSaleTime {
  weekDayBeginHour: string
  weekDayBeginMin: string
  weekDayFinishHour: string
  weekDayFinishMin: string
  weekEndBeginHour: string
  weekEndBeginMin: string
  weekEndFinishHour: string
  weekEndFinishMin: string
  useClosed: boolean
  weekDayString: string
  weekEndString: string
  dayOffString: string
  closedType?: WeekDayOffType
  closedDays?: WeekDayType[]
}

export interface ChannelImage {
  imageUrl: string
  imageName?: string
  width?: number
  height?: number
  fileSize?: number
  sortOrder?: number
  originalFileName?: string
  representative?: boolean
  imageClass?: ImageClass
}

export interface ChannelContact {
  displayTelNo?: boolean
  disabledDomesticTelNo?: boolean
  telNo?: Tel
  overseaTelNo?: Tel
  onlineSales?: boolean
  offlineSales?: boolean
  offlineStoreAddressInfo?: ChannelAddress
}

export interface ChannelAddress {
  apiType: string
  address: string
  basicAddress: string
  jibunAddress: string
  roadNameAddress: string
  massiveAddress: string
  detailAddress: string
  oldZipCode: string
  newZipCode: string
  overseas: boolean
  fullAddress: string
  latitude: number
  longitude: number
  placeId: string
  naverMapCode: string
  roadGroupId: string
  representAddressType: string
  fullAddressInfo: string
  hasRoadNameAddress: boolean
  zipCode: string
  hasJibunAddress: boolean
}

export interface Tel {
  countryCode?: string
  phoneNo: string
  formattedNumber: string
}

export enum ExternalStatus {
  NORMAL = 'NORMAL',
  JOIN_APPLY = 'JOIN_APPLY',
  STOP = 'STOP',
  DORMANCY = 'DORMANCY',
  LEAVE_APPLY = 'LEAVE_APPLY',
  REJECT = 'REJECT',
  LEAVE = 'LEAVE',
}

export const SNS = {
  NAVERBLOG: {
    class: 'blog',
    name: '블로그',
    domain: 'http://blog.naver.com',
    mobileDomain: 'http://m.blog.naver.com',
    nClickCode: 'blog',
  },
  INSTAGRAM: {
    class: 'instagram',
    name: '인스타그램',
    domain: 'https://instagram.com',
    nClickCode: 'insta',
  },
  FACEBOOK: {
    class: 'facebook',
    name: '페이스북',
    domain: 'https://www.facebook.com',
    nClickCode: 'fb',
  },
  TWITTER: {
    class: 'twitter',
    name: '트위터',
    domain: 'http://twitter.com',
    nClickCode: '',
  },
  TUMBLR: {
    class: 'tumblr',
    name: '텀블러',
    domain: 'http://tumblr.com',
    nClickCode: '',
  },
  PINTEREST: {
    class: 'pinterest',
    name: '핀터레스트',
    domain: 'http://pinterest.com',
    nClickCode: '',
  },
}

export const getStoreBackgroundImage = (additionalImages: ChannelImage[], subVertical: SubVertical): ChannelImage => {
  if (!additionalImages || !subVertical) return
  const result = additionalImages.find(image => {
    switch (subVertical) {
      case SubVertical.TRADITIONAL_ALCOHOL:
        return image.imageClass === ImageClass.TRADITIONAL_ALCOHOL_STORE
      case SubVertical.HOME_MEAL:
        return image.imageClass === ImageClass.HOME_MEAL_STORE
      default:
        return image.imageClass === ImageClass.STORE_MAIN_VIEW
    }
  })

  if (result && result.imageUrl) {
    result.imageUrl = replaceToHttps(result.imageUrl)
  }

  return result
}
